import {
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
  inject,
  viewChild,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { MatStepper } from '@angular/material/stepper';
import { TranslateService } from '@ngx-translate/core';
import { delay, finalize, takeUntil, tap } from 'rxjs/operators';

import { Location } from '@angular/common';
import { QueryStringTypesEnum } from 'src/app/configs/query-string-types';
import {
  BulkRecipientRequest,
  ComparisonOperator,
  CreateScheduledMessageBulkCommand,
  CustomResultOfGetWhiteMessageCalculationsDto,
  GenderType,
  GetEnumValuesDto,
  GetWhiteMessageCalculationsDto,
  SendTypes,
  SimType,
  SmsAggregator,
  SocialMediaSendDetailModel,
  UseTypes,
  VoiceMessageDetailsRequest,
  ZoneType,
} from 'src/app/core/api/models';
import {
  BulkServicesService,
  ScheduledMessagesService,
  ZonesService,
} from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { SendDateTimeType } from 'src/app/core/enums/send-date-time-type.enum';
import { CampaignInfoService } from 'src/app/core/services/campaign-info.service';
import {
  DialogService,
  DialogStatus,
} from 'src/app/core/services/dialog.service';
import { DynamicTabService } from 'src/app/core/services/dynamic-tab.service';
import { UtilityService } from 'src/app/core/services/utility.service';
import { BusinessGroupsSelectSearchComponent } from 'src/app/shared/components/select-search/business-group-select-search.component';
import { ZonesSelectSearchComponent } from 'src/app/shared/components/select-search/zones-select-search.component';
import { GetCountQuery } from '../../../core/api/models/get-count-query';
import { UpdateScheduledMessageBulkCommand } from '../../../core/api/models/update-scheduled-message-bulk-command';
import { FormPageConfig } from '../../../core/models/form-page-config.model';
import { NumberSeparatorPipe } from '../../../core/pipes/number.separator.pipe';
import { AppDomService } from '../../../core/services/dom.service';
import { BaseFormPageComponent } from '../../shared/base/components/base-form-page.component';
import {
  BaseSendSms,
  BaseSendSmsConfig,
} from '../base/base-send-sms/base-send-sms.component';
import { CampaignsFormComponent } from '../campaigns/campaigns-form/campaigns-form.component';
import { GetScheduledMessageCalculationsByBulkQuery } from './../../../core/api/models/get-scheduled-message-calculations-by-bulk-query';
import { DialogConfig } from './../../../core/services/dialog.service';
import { TabsDynamicComponent } from './../../../layout/components/tabs-dynamic/tabs-dynamic.component';
import { SendSmsConfirmationComponent } from './../send-sms-confirmation/send-sms-confirmation.component';
import { BalkSmsSendStepInformation } from './models/balk-sms-send-step-information';

@Component({
  selector: 'app-send-balk-sms',
  templateUrl: './send-balk-sms.component.html',
  styleUrls: [
    './send-balk-sms.component.scss',
    '../base/base-sending-system.component.scss',
  ],
  standalone: false,
})
export class SendBalkSmsComponent
  extends BaseFormPageComponent
  implements OnInit, OnDestroy
{
  tabName: string = 'sendBulkSMS';
  @Input() formPageConfig: FormPageConfig<any> = {};

  model: CreateScheduledMessageBulkCommand = {};
  smsCount: number;
  privateNumber: string;
  baseSendSmsConfig: BaseSendSmsConfig;

  calculateCountLoading: boolean = false;
  isStepTotalItemCountCalculated: boolean = false;
  location = inject(Location);

  //#region field's

  //#region select search's
  stateId: number = null;
  cityId: number = null;
  regionId: number = null;
  businessGroupId: number = null;
  businessSubGroupId: number = null;
  //#endregion

  //#region OtherData
  totalMobileCount: number = 0;
  smsCountToSendOnStep: number = 0;
  smsStartFromOnStep: number = 0;
  mobileNumberStartWith: string = '';
  mobileNumberTypeOnStep: SimType | null = SimType.All;
  mobileNumberOperatorIdOnStep: SmsAggregator | null = null;
  postalCode: string = '';
  totalSmsSendCount: number = -1;
  gender: GenderType | null = 0;
  description: string = '';
  //#endregion

  genderTypes: GetEnumValuesDto[] = [];
  operatorTypes: GetEnumValuesDto[] = [];
  simTypes: GetEnumValuesDto[] = [];

  queryForm: FormGroup;
  secondQueryForm: FormGroup;

  queries: BalkSmsSendStepInformation[] = [];
  isVisibleHelpPage: boolean = false;
  isWrongIndex: boolean = false;
  isRandomSend: boolean = false;
  showRefreshBtn: boolean = true;
  get ZoneType() {
    return ZoneType;
  }

  calcLoading: boolean;
  sendLoading: boolean;

  //#endregion

  errorsVocab: string = '';

  states: any[] = [];
  cities: any[] = [];

  readonly selStates = viewChild<ZonesSelectSearchComponent>('selStates');
  readonly selCities = viewChild<ZonesSelectSearchComponent>('selCities');
  readonly selRegions = viewChild<ZonesSelectSearchComponent>('selRegions');
  readonly selBusinessGroups =
    viewChild<BusinessGroupsSelectSearchComponent>('selBusinessGroups');
  readonly selBusinessSubGroups =
    viewChild<BusinessGroupsSelectSearchComponent>('selBusinessSubGroups');
  readonly matNumberType = viewChild<MatSelect>('matNumberType');
  readonly matOperatorType = viewChild<any>('matOperatorType');
  readonly stepper = viewChild<MatStepper>('stepper');
  protected apiMethodName: string =
    'scheduledMessagesCreateScheduledMessageBulkGet';

  constructor(
    public dynamicTabService: DynamicTabService,
    protected translate: TranslateService,
    public dialogService: DialogService,
    public utilityService: UtilityService,
    protected currentService: ScheduledMessagesService,
    public CD: ChangeDetectorRef,
    public zoneService: ZonesService,
    public bulkService: BulkServicesService,
    protected tabsDynamicComponent: TabsDynamicComponent,
    protected numberSeparatorPipe: NumberSeparatorPipe
  ) {
    super();
  }

  ngOnInit(): void {
    try {
      this.baseCreateGetApiForSend(this.currentService, this.apiMethodName);
      super.ngOnInit();
      this.privateNumber = this.formPageConfig?.editData?.senderNumber;
      this.configBaseSendSMS();
      this.fields = 'pages.sendBalkSms.fields.';
      this.errorsVocab = 'pages.sendBalkSms.errors.';
      this.pageVocabs = 'pages.sendSMS.';
      this.fetchEnums();
      if (CampaignInfoService.lastCampaignInfo) this.getCampaignModelData();

      if (CampaignInfoService.lastCampaignInfo.id) {
        this.location.go(
          window.location.pathname +
            '?' +
            QueryStringTypesEnum.Campaign_key +
            '=' +
            CampaignInfoService.lastCampaignInfo.id
        );
        this.showRefreshBtn = false;
      }
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  closeThisTab() {
    try {
      const TimeOut = setTimeout(() => {
        this.tabsDynamicComponent.manualCloseTab(this.tabName);
        clearTimeout(TimeOut);
      }, 50);
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  ngAfterViewInit(): void {
    try {
      const timeOut = setTimeout(() => {
        if (this.formPageConfig.isEditMode) this.getEditModelData();
        clearTimeout(timeOut);
      }, 1000);
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  getEditModelData() {
    try {
      if (!this.formPageConfig.isEditMode) return;
      this.formPageConfig.editData.bulkRecipients.forEach((item, index) => {
        this.queries[index] = {};

        // this.cityId = item?.cityId;
        // this.stateId = item?.stateId;
        // this.regionId = item?.areaId;
        // this.businessGroupId = item?.guildId;
        // this.businessSubGroupId = item?.subGuildId;

        // this.calculateStepTotalItemCount();

        // this.queries[index].totalMobileCount = this.totalMobileCount;

        if (item?.cityId) this.queries[index].cityId = item?.cityId;
        if (item?.stateId) this.queries[index].stateId = item?.stateId;
        if (item?.areaId) this.queries[index].regionId = item?.areaId;
        if (item?.genderTye) this.queries[index].gender = item?.genderTye;
        if (item?.description) this.queries[index].Text = item?.description;
        if (item?.fromIndex)
          this.queries[index].smsStartFromOnStep = item?.fromIndex;
        if (item?.count) this.queries[index].smsCountToSendOnStep = item?.count;
        if (item?.totalCount)
          this.queries[index].totalMobileCount = item?.totalCount;
        if (item?.guildId) this.queries[index].businessGroupId = item?.guildId;
        if (item?.subGuildId)
          this.queries[index].businessSubGroupId = item?.subGuildId;
        if (item?.zipCode)
          this.queries[index].postalCode = item?.zipCode.toString();
        if (item?.preFix)
          this.queries[index].mobileNumberStartWith = [
            '98',
            '9898',
            '989898',
          ].includes(item.preFix?.toString())
            ? ''
            : item?.preFix?.toString();
        if (item?.simType)
          this.queries[index].mobileNumberTypeOnStep = item?.simType;
        if (item?.aggregatorType)
          this.queries[index].mobileOperatorIdOnStep = item?.aggregatorType;

        let itemForGenerateText: BalkSmsSendStepInformation =
          this.queries[index];
        if (item?.preFix)
          itemForGenerateText.mobileNumberStartWith = [
            '98',
            '9898',
            '989898',
          ].includes(item.preFix?.toString())
            ? ''
            : item?.preFix?.toString();

        //itemForGenerateText.Text = '';

        const timeOut = setTimeout(() => {
          // this.queries[index].Text = this.stepItemToText(itemForGenerateText);
          this.model.bulkRecipients[index].description =
            this.queries[index].Text;
          clearTimeout(timeOut);
        }, 1000);
      });

      this.calculateTotalSmsMostSent();
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  getCampaignModelData() {
    try {
      let recipientsJson = JSON.parse(
        CampaignInfoService.lastCampaignInfo.recipientsJson
      );
      recipientsJson.forEach((item, index) => {
        this.queries[index] = {};

        if (item?.cityId) this.queries[index].cityId = item?.cityId;
        if (item?.stateId) this.queries[index].stateId = item?.stateId;
        if (item?.areaId) this.queries[index].regionId = item?.areaId;
        if (item?.genderTye) this.queries[index].gender = item?.genderTye;
        if (item?.description) this.queries[index].Text = item?.description;
        if (item?.fromIndex)
          this.queries[index].smsStartFromOnStep = item?.fromIndex;
        if (item?.count) this.queries[index].smsCountToSendOnStep = item?.count;
        if (item?.guildId) this.queries[index].businessGroupId = item?.guildId;
        if (item?.subGuildId)
          this.queries[index].businessSubGroupId = item?.subGuildId;
        if (item?.zipCode)
          this.queries[index].postalCode = item?.zipCode.toString();
        if (item?.preFix)
          this.queries[index].mobileNumberStartWith = [
            '98',
            '9898',
            '989898',
          ].includes(item.preFix?.toString())
            ? ''
            : item?.preFix?.toString();
        if (item?.simType)
          this.queries[index].mobileNumberTypeOnStep = item?.simType;
        if (item?.aggregatorType)
          this.queries[index].mobileOperatorIdOnStep = item?.aggregatorType;

        let itemForGenerateText: BalkSmsSendStepInformation =
          this.queries[index];
        if (item?.preFix) {
          if (item?.preFix?.toString()?.startsWith('98')) {
            itemForGenerateText.mobileNumberStartWith = [
              '98',
              '9898',
              '989898',
            ].includes(item.preFix?.toString())
              ? ''
              : item?.preFix?.toString();
          } else
            itemForGenerateText.mobileNumberStartWith =
              '98' +
              (['98', '9898', '989898'].includes(item.preFix?.toString())
                ? ''
                : item?.preFix?.toString());
        }

        const timeOut = setTimeout(() => {
          this.model.bulkRecipients[index].description =
            this.queries[index].Text;
          clearTimeout(timeOut);
        }, 1000);
      });

      this.calculateTotalSmsMostSent();
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  //#region base send sms

  configBaseSendSMS() {
    try {
      this.baseSendSmsConfig = {
        title: this.pageVocabs + 'title',
        isEdit: this.formPageConfig.isEditMode,
        msgInfoClassList: 'md:tw-w-5/12 xl:tw-w-1/3 tw-mt-2 offset-xl-2',
        sendDateTimeClassList: 'md:tw-w-5/12 xl:tw-w-1/3 tw-mt-2',
        isShowReceivers: false,
        isShowFastSend: false,
        isShowExtraReceivers: true,
        isShowPageHeader: false,
        isShowCampaign: true,
        isAddSignature: !this.formPageConfig?.isEditMode ? true : false,
        isAddHeader: !this.formPageConfig?.isEditMode ? true : false,
        sendType: SendTypes.Bulk,
        useType: UseTypes.Normal,
      };
      if (this.formPageConfig.isEditMode) {
        this.baseSendSmsConfig.isEdit = true;
        this.baseSendSmsConfig.isShowExtraReceivers = false;
        // this.baseSendSmsConfig.justShowDirectDateTimeForEdit = true;
      }
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  getBaseSendSmsModel(baseModel: BaseSendSms) {
    try {
      this.smsCount = baseModel.smsCount;
      this.model.smsBody = baseModel.finalSmsBody;
      this.model.senderNumberId = baseModel.senderNumberId;
      this.model.isSendWhiteList = baseModel.isSendWhiteList;
      this.model.isFlashSms = baseModel.isFlashSms;
      this.model.description = baseModel.description;
      this.model.receivers = baseModel.zipExtraReceivers;

      this.handleVoiceMessage(
        baseModel.isCanSendVoice,
        baseModel.voiceMessageDetails
      );

      this.handleSocialMediaMessage(
        baseModel.isCanSendSocialMedia,
        baseModel.socialMediaMessageDetails
      );

      if (baseModel.campaignId) this.model.campaignId = baseModel.campaignId;
      // if (baseModel.recipientsJson)
      //   this.getRecipients(baseModel.recipientsJson);

      //direct
      this.model.sendDateTimeChecked =
        baseModel.sendDateTimeType == SendDateTimeType.DateTime ||
        baseModel.sendDateTimeType == undefined
          ? true
          : false;
      this.model.sendDateTime = baseModel.directSendDateTime;
      // period
      this.model.sendPeriodChecked =
        baseModel.sendDateTimeType == SendDateTimeType.Period ? true : false;
      this.model.periodStart = baseModel.periodicSendStartDateTime;
      this.model.periodEnd = baseModel.periodicSendEndDateTime;
      this.model.periodText = baseModel.gradualPeriodText;
      this.model.periodTypeValue = baseModel.periodTypeValue;
      this.model.isSendWhiteList = baseModel.isSendWhiteList;
      this.model.isFlashSms = baseModel.isFlashSms;
      // gradual
      this.model.gradualChecked =
        baseModel.sendDateTimeType == SendDateTimeType.Gradual ? true : false;
      this.model.gradualStart = baseModel.gradualSendDateTime;
      this.model.gradualPageSize = baseModel.gradualPageSize;
      this.model.gradualPeriodText = baseModel.gradualPeriodText;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  handleVoiceMessage(
    isCanSendVoice,
    voiceMessageDetails: VoiceMessageDetailsRequest
  ) {
    try {
      if (isCanSendVoice) {
        if (voiceMessageDetails)
          this.model.voiceMessageDetails = voiceMessageDetails;

        this.model.campaignId = null;
        this.model.title = null;
        this.baseSendSmsConfig.isShowCampaign = false;
        this.baseSendSmsConfig = Object.assign({}, this.baseSendSmsConfig);
      } else {
        this.baseSendSmsConfig.isShowCampaign = true;
        this.baseSendSmsConfig = Object.assign({}, this.baseSendSmsConfig);
        this.model.voiceMessageDetails = null;
      }
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  handleSocialMediaMessage(
    isCanSendSocialMedia,
    socialMediaMessageDetails: SocialMediaSendDetailModel
  ) {
    try {
      if (isCanSendSocialMedia) {
        if (socialMediaMessageDetails)
          this.model.socialMediaDetails = socialMediaMessageDetails;

        this.model.campaignId = null;
        this.model.title = null;
        this.baseSendSmsConfig.isShowCampaign = false;
        this.baseSendSmsConfig = Object.assign({}, this.baseSendSmsConfig);
      } else {
        this.baseSendSmsConfig.isShowCampaign = true;
        this.baseSendSmsConfig = Object.assign({}, this.baseSendSmsConfig);
        this.model.socialMediaDetails = null;
      }
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  getRecipients(recipientsJson: string) {
    try {
      const recipients = JSON.parse(recipientsJson);
      recipients.forEach((item, index) => {
        this.queries[index] = {};

        this.cityId = item?.cityId;
        this.stateId = item?.stateId;
        this.regionId = item?.areaId;
        this.businessGroupId = item?.guildId;
        this.businessSubGroupId = item?.subGuildId;

        this.calculateStepTotalItemCount();

        if (item?.cityId) this.queries[index].cityId = item?.cityId;
        if (item?.stateId) this.queries[index].stateId = item?.stateId;
        if (item?.areaId) this.queries[index].regionId = item?.areaId;
        if (item?.genderTye) this.queries[index].gender = item?.genderTye;
        if (item?.fromIndex)
          this.queries[index].smsStartFromOnStep = item?.fromIndex;
        if (item?.count) this.queries[index].smsCountToSendOnStep = item?.count;
        if (item?.totalCount)
          this.queries[index].totalMobileCount = item?.totalCount;
        if (item?.guildId) this.queries[index].businessGroupId = item?.guildId;
        if (item?.subGuildId)
          this.queries[index].businessSubGroupId = item?.subGuildId;
        if (item?.zipCode)
          this.queries[index].postalCode = item?.zipCode.toString();
        if (item?.preFix)
          this.queries[index].mobileNumberStartWith = [
            '98',
            '9898',
            '989898',
          ].includes(item.preFix.toString())
            ? ''
            : item?.preFix.toString();
        if (item?.simType)
          this.queries[index].mobileNumberTypeOnStep = item?.simType;
        if (item?.aggregatorType)
          this.queries[index].mobileOperatorIdOnStep = item?.aggregatorType;

        let itemForGenerateText: BalkSmsSendStepInformation =
          this.queries[index];

        itemForGenerateText.mobileNumberStartWith =
          '98' +
          (['98', '9898', '989898'].includes(item.preFix.toString())
            ? ''
            : item?.preFix.toString());

        itemForGenerateText.Text = '';

        const timeOut = setTimeout(() => {
          this.queries[index].Text = this.stepItemToText(itemForGenerateText);
          if (!this.model.bulkRecipients) {
            this.model.bulkRecipients = [];
            this.model.bulkRecipients[index] = {};
          }
          this.model.bulkRecipients[index].description =
            this.queries[index]?.Text;
          clearTimeout(timeOut);
        }, 1000);
      });

      this.calculateTotalSmsMostSent();
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  //#endregion

  //#region api

  createScheduledMessageBulkApi(
    requestModel: CreateScheduledMessageBulkCommand
  ) {
    this.unSubs();
    this.loading = true;
    this.sendLoading = true;

    this.currentService
      .scheduledMessagesCreateScheduledMessageBulkPost({
        body: requestModel,
      })
      .pipe(
        this.basePipeOperators(),
        finalize(() => (this.sendLoading = false))
      )
      .subscribe((result) => {
        try {
          this.apiNotificationService.notifyMessage({
            result,
            mode: 'matDialog',
          });
          if (result.isSucceed) {
            this.refreshPage();
            this.onSuccess();
          }
        } catch (error) {
          this.loggerService.logError(
            this.tagName,
            error,
            EventTypes.sendingSystem
          );
        }
      });
  }

  scheduledMessageCalculationsApi(
    model: GetScheduledMessageCalculationsByBulkQuery
  ) {
    this.unSubs();
    this.loading = true;
    this.calcLoading = true;

    this.currentService
      .scheduledMessagesGetScheduledMessageCalculationsByBulk({ body: model })
      .pipe(
        delay(500),
        tap((res: CustomResultOfGetWhiteMessageCalculationsDto) => {
          if (res.isSucceed) this.onConfirmation(res?.data);
        }),
        this.basePipeOperators(),
        finalize(() => (this.calcLoading = false))
      )
      .subscribe();
  }

  updateScheduledMessageBulkApi() {
    this.unSubs();
    this.loading = true;
    this.sendLoading = true;
    let requestModel: UpdateScheduledMessageBulkCommand = {};
    requestModel = {
      id: this.formPageConfig.editId,
      sendDateTime: this.model.sendDateTime,
      smsText: this.model.smsBody,
      privateNumberId: this.model.senderNumberId,
      description: this.model.description,
      sendDateTimeChecked: this.model.sendDateTimeChecked,
      bulkRecipients: this.model.bulkRecipients,
      isSendWhiteList: this.formPageConfig.editData.isSendWhiteList,
      isFlashSms: this.formPageConfig.editData.isFlashSms,
      gradualChecked: this.model.gradualChecked,
      gradualPageSize: this.model.gradualPageSize,
      gradualPeriodText: this.model.gradualPeriodText,
      gradualStart: this.model.gradualStart,
      voiceMessageDetails: this.model.voiceMessageDetails,
      socialMediaDetails: this.model?.socialMediaDetails,
    };
    requestModel.id = this.formPageConfig.editId;

    this.currentService
      .scheduledMessagesUpdateScheduledMessageBulkPut({
        body: requestModel,
      })
      .pipe(
        this.basePipeOperators(),
        finalize(() => (this.sendLoading = false))
      )
      .subscribe((result) => {
        this.apiNotificationService.notifyMessage({
          result,
          mode: 'matDialog',
        });
        if (result?.isSucceed) this.onSuccess();
      });
  }

  //#endregion

  onConfirmation(model: GetWhiteMessageCalculationsDto) {
    try {
      this.unSubs();

      let data = {
        model: model,
        smsCount: this.smsCount,
        sendType: SendTypes.Bulk,
        privateNumber: this.privateNumber,
      };

      const modalResult = this.dialogService.openModal({
        component: SendSmsConfirmationComponent,
        data: data,
      });

      modalResult
        .afterClosed()
        .pipe(
          takeUntil(this.onDestroy$),
          tap(() => {
            AppDomService.removeModalScrollClassFromHtml();
          })
        )
        .subscribe((confirm) => {
          if (confirm) {
            if (!this.formPageConfig.isEditMode)
              this.createScheduledMessageBulkApi(this.model);
            else this.updateScheduledMessageBulkApi();
          }
        });
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  async fetchEnums() {
    try {
      this.getEnumValuesApi('SimType').subscribe((result) => {
        this.simTypes = result;
        this.mobileNumberTypeOnStep = result[0].key;
      });

      this.getEnumValuesApi('SmsAggregator').subscribe((result) => {
        this.operatorTypes = result;
        this.mobileNumberOperatorIdOnStep = result[1].key;
      });

      this.getEnumValuesApi('GenderType').subscribe((result) => {
        this.genderTypes = result;
      });
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  //#region inherited member's
  initForm() {
    this.queryForm = new FormGroup({
      stateControl: new FormControl('', Validators.required),
      cityControl: new FormControl(''),
      regionControl: new FormControl(''),
      businessGroupControl: new FormControl(''),
      businessSubGroupControl: new FormControl(''),
      totalSendControl: new FormControl('', Validators.min(1)),
    });
    this.secondQueryForm = new FormGroup({
      //  Validators.max(this.totalMobileCount)
      startFromControl: new FormControl(''),
      countToSendControl: new FormControl(''),
      prefixControl: new FormControl(
        '',
        Validators.pattern('^(?!0)[0-9]{2,6}')
      ),
      postalCodeControl: new FormControl('', Validators.pattern('[0-9]{2,6}')),
      operatorTypeControl: new FormControl(),
      mobileNumberTypeControl: new FormControl('', Validators.required),
      genderControl: new FormControl(''),
      zonePostalCodeControl: new FormControl(''),
      isRandomSend: new FormControl(''),
    });
    this.form = new FormGroup({});
  }

  //#endregion

  //#region method's

  openPage(tabName: string) {
    try {
      this.dynamicTabService.setNewTab('');
      this.dynamicTabService.setNewTab(tabName);
      this.dynamicTabService.setActiveTab(tabName);
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  selectedItemsChanged(event: any, fieldName: string) {
    try {
      this.checkValidations(fieldName);
      this[fieldName] = event;
      if (event == null && fieldName == 'businessGroupId') return;
      this.calculateStepTotalItemCount();
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }
  checkValidations(fieldName) {
    try {
      if (fieldName == 'stateId' || fieldName == 'cityId') {
        this.cityId = null;
        this.regionId = null;
      }
      if (fieldName == 'businessGroupId') this.businessSubGroupId = null;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  onChangeSecondaryQueryFilter() {
    this.isStepTotalItemCountCalculated = false;
  }

  resetOtherData() {
    this.mobileNumberOperatorIdOnStep = SmsAggregator.MCI;
    this.mobileNumberStartWith = '';
    this.gender = 0;
    this.postalCode = '';
    this.regionId = null;
    this.businessGroupId = null;
    this.businessSubGroupId = null;
    // this.totalMobileCount = 0;
    // this.smsCountToSendOnStep = 0;
    // this.smsStartFromOnStep = 0;
    // this.totalSmsSendCount = -1;
    //this.mobileNumberTypeOnStep = SimType.All;
  }

  createRegionQuery() {
    try {
      //this.calculateStepTotalItemCount(false);
      //first most check total mobile number and number of sms most sent
      if (!this.secondQueryForm.valid) {
        this.dialogService.openDialog({
          title: this.translate.instant('common.error'),
          message: this.translate.instant(
            this.errorsVocab + 'pleaseEnterValidDateForSend'
          ),
          status: DialogStatus.error,
        });
        return;
      }
      if (this.totalMobileCount > 0) {
        let item: BalkSmsSendStepInformation = {
          businessGroupId: this.businessGroupId,
          businessSubGroupId: this.businessSubGroupId,
          cityId: this.cityId,
          mobileNumberStartWith: '98' + this.mobileNumberStartWith,
          mobileNumberTypeOnStep: this.mobileNumberTypeOnStep,
          mobileOperatorIdOnStep: this.mobileNumberOperatorIdOnStep,
          postalCode: this.postalCode,
          regionId: this.regionId,
          smsCountToSendOnStep: this.smsCountToSendOnStep,
          smsStartFromOnStep: !this.isRandomSend ? this.smsStartFromOnStep : -1,
          stateId: this.stateId,
          totalMobileCount: this.totalMobileCount,
          Text: '',
          gender: this.gender,
        };
        item.Text = this.stepItemToText(item);
        this.description = item.Text;
        if (
          item.smsStartFromOnStep + item.smsCountToSendOnStep - 1 >
          item.totalMobileCount
        ) {
          this.dialogService.openDialog({
            title: this.translate.instant('common.error'),
            message: this.translate.instant(
              this.errorsVocab + 'smsCountBiggerThanTotal'
            ),
            status: DialogStatus.error,
          });
          return;
        }

        this.queries.push(item);
        // this.model.bulkRecipients.push(item)
        //empty fields after add new query
        this.resetOtherData();
        this.calculateStepTotalItemCount();

        this.calculateTotalSmsMostSent();
        this.CD.detectChanges();
      } else {
        this.dialogService.openDialog({
          title: this.translate.instant('common.error'),
          message: this.translate.instant(this.errorsVocab + 'emptyRegion'),
          status: DialogStatus.error,
        });
      }
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }
  //#endregion

  deleteItemFromQuery(item) {
    try {
      let dialogResult = this.dialogService.confirmDialog({
        content: item.Text,
        isConfirmDelete: true,
        confirmByWritingText: false,
      });
      dialogResult
        .afterClosed()
        .pipe(takeUntil(this.onDestroy$))
        .subscribe((result) => {
          if (result) {
            this.queries.splice(this.queries.indexOf(item), 1);
            this.calculateTotalSmsMostSent();
            this.CD.detectChanges();
          }
        });
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  changeIndex() {
    if (
      this.smsStartFromOnStep + this.smsCountToSendOnStep >
      this.totalMobileCount + 1
    )
      this.isWrongIndex = true;
    else this.isWrongIndex = false;
  }

  stepItemToText(item: BalkSmsSendStepInformation): string {
    try {
      let result: string = '';
      let separator = ' ';
      const selStates = this.selStates();
      if (item.stateId && selStates?.items) {
        for (let index = 0; index < selStates?.items.length; index++) {
          if (selStates?.items[index].id == item.stateId)
            result +=
              this.translate.instant('common.state') +
              separator +
              selStates?.items[index].name;
        }
        result += separator;
      }
      const selCities = this.selCities();
      if (item.cityId && selCities?.items) {
        for (let index = 0; index < selCities.items.length; index++) {
          if (selCities.items[index].id == item.cityId)
            result +=
              this.translate.instant('common.city') +
              separator +
              selCities.items[index].name;
        }
        result += separator;
      }
      const selRegions = this.selRegions();
      if (item.regionId && selRegions?.items) {
        for (let index = 0; index < selRegions.items.length; index++) {
          if (selRegions.items[index].id == item.regionId)
            result +=
              this.translate.instant(this.fields + 'region') +
              separator +
              selRegions.items[index].name;
        }
        result += separator;
      }
      const selBusinessGroups = this.selBusinessGroups();
      if (item.businessGroupId && selBusinessGroups?.items) {
        for (let index = 0; index < selBusinessGroups.items.length; index++) {
          if (selBusinessGroups.items[index].id == item.businessGroupId)
            result +=
              this.translate.instant(this.fields + 'businessGroup') +
              separator +
              selBusinessGroups.items[index].name;
        }
        result += separator;
      }
      const selBusinessSubGroups = this.selBusinessSubGroups();
      if (item.businessSubGroupId && selBusinessSubGroups?.items) {
        for (
          let index = 0;
          index < selBusinessSubGroups.items.length;
          index++
        ) {
          if (selBusinessSubGroups.items[index].id == item.businessSubGroupId)
            result +=
              this.translate.instant(this.fields + 'businessSubGroup') +
              separator +
              selBusinessSubGroups.items[index].name;
        }
        result += separator;
      }
      const matNumberType = this.matNumberType();
      if (item.mobileNumberTypeOnStep && matNumberType?.options) {
        let ar = matNumberType.options.toArray();
        for (let index = 0; index < ar.length; index++) {
          if (ar[index].value == item.mobileNumberTypeOnStep)
            result +=
              this.translate.instant(this.fields + 'mobileType') +
              separator +
              ar[index].getLabel();
        }
        result += separator;
      }
      const matOperatorType = this.matOperatorType();
      if (item.mobileOperatorIdOnStep && matOperatorType?.items) {
        let ar = matOperatorType?.items;
        for (let index = 0; index < ar.length; index++) {
          if (ar[index].id == item.mobileOperatorIdOnStep)
            result +=
              this.translate.instant(this.fields + 'operatorType') +
              separator +
              ar[index].name;
        }
        result += separator;
      }
      if (item.postalCode && item.postalCode.length > 0) {
        result +=
          this.translate
            .instant(this.fields + 'postalCodeContains')
            .replaceAll('%s', item.postalCode) + separator;
      }
      if (item.mobileNumberStartWith && item.mobileNumberStartWith.length > 0) {
        result +=
          this.translate
            .instant(this.fields + 'asIfStartWith')
            .replaceAll('%s', item.mobileNumberStartWith) + separator;
      }
      if (item.smsStartFromOnStep == -1) {
        result += this.translate.instant('common.isRandomSend') + separator;
      }
      if (item.totalMobileCount)
        result +=
          this.translate.instant(this.fields + 'totalMobileNumber') +
          separator +
          this.numberSeparatorPipe.transform(item.totalMobileCount);

      result = result.replaceAll('  ', ' ');
      return result;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  calculateTotalSmsMostSent() {
    try {
      let total = 0;
      this.queries.forEach((item) => {
        total += item.smsCountToSendOnStep;
      });
      this.totalSmsSendCount = total;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  canCalculateStepTotalItemCount(): boolean {
    try {
      if (this.stateId == null) return false;
      if (this.mobileNumberStartWith.length > 6) return false;
      if (
        this.postalCode?.length > 0 &&
        (this.postalCode?.length < 2 || this.postalCode?.length > 6)
      )
        return false;
      if (
        this.mobileNumberStartWith.length > 0 &&
        this.mobileNumberStartWith.length < 2
      )
        return false;
      return true;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  calculateStepTotalItemCount(changeInputs: boolean = true) {
    try {
      if (this.calculateCountLoading) return;
      this.calculateCountLoading = true;

      this.totalMobileCount = 0;
      if (changeInputs) {
        this.smsStartFromOnStep = 0;
        this.smsCountToSendOnStep = this.totalMobileCount;
      }

      let model: GetCountQuery = {
        comparisonObjects: [],
        orders: null,
      };
      if (this.stateId && this.stateId != null) {
        model.comparisonObjects.push({
          field: 'StateId',
          operator: ComparisonOperator.EqualTo,
          value: this.stateId.toString(),
        });
      }
      // else {
      //   //here we return to force the user to select a city
      //   this.dialogService.openDialog({
      //     message: this.translate.instant(this.errorsVocab + "mostSelectAtLeastState"),
      //     title: this.translate.instant("common.error"),
      //     status: DialogStatus.error
      //   })
      //   this.calculateCountLoading=false;
      //   return;
      // }
      if (this.cityId && this.cityId != null) {
        model.comparisonObjects.push({
          field: 'CityId',
          operator: ComparisonOperator.EqualTo,
          value: this.cityId.toString(),
        });
      }
      if (this.regionId && this.regionId != null) {
        model.comparisonObjects.push({
          field: 'AreaId',
          operator: ComparisonOperator.EqualTo,
          value: this.regionId.toString(),
        });
      }
      if (this.businessGroupId && this.businessGroupId != null) {
        model.comparisonObjects.push({
          field: 'GuildId',
          operator: ComparisonOperator.EqualTo,
          value: this.businessGroupId.toString(),
        });
      }
      if (this.businessSubGroupId && this.businessSubGroupId != null) {
        model.comparisonObjects.push({
          field: 'SubGuildId',
          operator: ComparisonOperator.EqualTo,
          value: this.businessSubGroupId.toString(),
        });
      }
      if (this.mobileNumberOperatorIdOnStep != null) {
        model.comparisonObjects.push({
          field: 'MobileOperator',
          operator: ComparisonOperator.EqualTo,
          value: this.mobileNumberOperatorIdOnStep.toString(),
        });
      }
      if (this.mobileNumberStartWith.length > 0) {
        let fldName = 'Mobile';
        model.comparisonObjects.push({
          field: fldName,
          operator: ComparisonOperator.StartsWith,
          value: '98' + this.mobileNumberStartWith,
        });
      }
      if (this.mobileNumberTypeOnStep != null) {
        model.comparisonObjects.push({
          field: 'SimType',
          operator: ComparisonOperator.EqualTo,
          value: this.mobileNumberTypeOnStep.toString(),
        });
      } else {
        //here we return to force the user to select a simType
        this.dialogService.openDialog({
          message: this.translate.instant(
            this.errorsVocab + 'mostSelectAtLeastSimType'
          ),
          title: this.translate.instant('common.error'),
          status: DialogStatus.error,
        });
        this.calculateCountLoading = false;
        return;
      }
      if (this.gender != null) {
        model.comparisonObjects.push({
          field: 'GenderType',
          operator: ComparisonOperator.EqualTo,
          value: this.gender.toString(),
        });
      }
      if (this.postalCode.length > 0) {
        let fldName = 'ZipCode';
        model.comparisonObjects.push({
          field: fldName,
          operator: ComparisonOperator.StartsWith,
          value: this.postalCode,
        });
      }
      this.bulkService
        .bulkServicesGetCount({ body: model })
        .pipe(
          takeUntil(this.onDestroy$),
          finalize(
            () => ((this.loading = false), (this.calculateCountLoading = false))
          )
        )
        .subscribe((res) => {
          this.calculateCountLoading = false;
          this.totalMobileCount = res?.data;
          if (changeInputs) {
            this.smsStartFromOnStep = 1;
            this.smsCountToSendOnStep = this.totalMobileCount;
            if (this.totalMobileCount == 0) this.smsStartFromOnStep = 0;
          }
        });

      this.isStepTotalItemCountCalculated = true;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  moveToStep2() {
    try {
      if (this.totalSmsSendCount > 0) {
        this.stepper().next();
      } else {
        this.dialogService.openDialog({
          title: this.translate.instant('common.error'),
          message: this.translate.instant(
            this.errorsVocab + 'firstSelectWhereToSendSms'
          ),
          status: DialogStatus.info,
        });
      }
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  onSubmit() {
    try {
      if (!this.isValidForm(this.form, this.tagName)) return;

      this.createModel();

      //create
      //if (!this.formPageConfig.isEditMode)
      if (
        this.model.bulkRecipients.length >
        this.currentUserInfo?.bulkRecipientsCountLimitation
      ) {
        this.dialogService.openDialog({
          message: this.translate.instant('messages.bulkRecipientsLimitation', {
            count: this.currentUserInfo?.bulkRecipientsCountLimitation,
          }),
          title: this.translate.instant('common.error'),
          status: DialogStatus.error,
        });
        return;
      }
      this.scheduledMessageCalculationsApi({
        smsText: this.model.smsBody,
        senderNumberId: this.model.senderNumberId,
        bulkRecipients: this.model.bulkRecipients,
        voiceMessageId: this.model?.voiceMessageDetails?.voiceMessageId || null,
        socialMediaDetails: this.model?.socialMediaDetails || null,
        receivers: this.model.receivers,
      });

      // edit
      //if (this.formPageConfig.isEditMode)
      //this.updateScheduledMessageBulkApi();
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  createModel() {
    try {
      let requestModel: CreateScheduledMessageBulkCommand = {};
      requestModel = this.model;
      requestModel.bulkRecipients = [];
      //#region generate queries for bulk send
      this.queries.forEach(function (query) {
        let serverQuery: BulkRecipientRequest = {};
        if (
          query.mobileNumberTypeOnStep != null &&
          query.mobileNumberTypeOnStep != null
        )
          serverQuery.simType = query.mobileNumberTypeOnStep;
        if (
          query.mobileOperatorIdOnStep != null &&
          query.mobileOperatorIdOnStep != null
        )
          serverQuery.aggregatorType = query.mobileOperatorIdOnStep;
        if (query.businessGroupId && query.businessGroupId != null)
          serverQuery.guildId = query.businessGroupId;
        if (query.businessSubGroupId && query.businessSubGroupId != null)
          serverQuery.subGuildId = query.businessSubGroupId;
        if (query.stateId && query.stateId != null)
          serverQuery.stateId = query.stateId;
        if (query.cityId && query.cityId != null)
          serverQuery.cityId = query.cityId;
        if (query.regionId && query.regionId != null)
          serverQuery.areaId = query.regionId;
        if (query.postalCode && query.postalCode.length > 0)
          serverQuery.zipCode = Number.parseInt(query.postalCode);
        if (query.smsStartFromOnStep)
          serverQuery.fromIndex = query.smsStartFromOnStep;
        if (query.smsCountToSendOnStep)
          serverQuery.count = query.smsCountToSendOnStep;
        if (query.gender && query.gender != null)
          serverQuery.genderTye = query.gender;
        if (query.totalMobileCount && query.totalMobileCount != null)
          serverQuery.totalCount = query.totalMobileCount;
        if (
          query.mobileNumberStartWith &&
          query.mobileNumberStartWith.length > 0
        )
          serverQuery.preFix = Number.parseInt(query.mobileNumberStartWith);

        if (query.Text && query.Text != null)
          serverQuery.description = query.Text;
        requestModel.bulkRecipients?.push(serverQuery);
      });
      //#endregion

      this.model = requestModel;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  onShowAlertInEditMode() {
    try {
      let title = this.translate.instant(`common.warning`);

      let message = this.translate.instant(
        'pages.sendingSystem.sendBalkSms.yourSendingIsInUpdateStatus'
      );

      const confirmDialogConfig: DialogConfig = {
        message: message,
        title: title,
        status: DialogStatus.warning,
      };

      let dialogResult = this.dialogService.openDialog(confirmDialogConfig);
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }
  onShowHelpPage() {
    this.isVisibleHelpPage = true;
  }
  onHideHelpPage() {
    this.isVisibleHelpPage = false;
  }
  refreshPage() {
    this.tabsDynamicComponent.refreshTab(this.tabName);
  }

  getPrivateNumber(number: string) {
    this.privateNumber = number;
  }

  onSaveToCampaign(event) {
    try {
      this.model.saveToCampaign = event;
      this.createModel();

      const modalResult = this.dialogService.openModal({
        component: CampaignsFormComponent,
        data: { model: this.model, sendType: SendTypes.Bulk },
      });

      modalResult
        .afterClosed()
        .pipe(
          takeUntil(this.onDestroy$),
          tap(() => {
            AppDomService.removeModalScrollClassFromHtml();
          })
        )
        .subscribe((res) => {
          this.model.saveToCampaign = res?.isSaveAfterSend;
          if (res?.campaignId) this.model.campaignId = res?.campaignId;
          if (res?.title) this.model.title = res?.title;
        });
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }
}
